import axios from "axios";
import Cookies from "js-cookie";

const api = axios.create({ 
  baseURL: 'https://testingapi.photoboothx.ca/api/',
  withCredentials: true  // Ensure credentials (cookies) are sent with every request
});

api.interceptors.request.use((config) => {
  const jwt = Cookies.get("jwt");

  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`;
  }

  return config;
});

export default api;
